import { PROFILE_KEY } from '../../../../../models/profile/constants'
import { getActionStrReduxUtil } from '../../../../redux/utils/get-action-str'
import { REDUX_ACTION_PREFIX } from '../../../../redux/constants/action'
import { updateProfileAction } from '../../actions/update'
import { MACRONUTRIENT, MACRONUTRIENT_TO_CALORIES_PER_GRAM } from '../../../../meal/constants'
import { getDailyCalorieIntakeGoalProfileSelect } from '../../selectors/get-daily-calorie-intake-goal'
import { updateDailyCarbsIntakeGoalPercentageProfileAction } from '../update-daily-carbs-intake-percentage-goal'
import { balanceDailyMacroIntakeGoalPercentageProfileAction } from '../balance-daily-macro-intake-goal-percentage'

/**
 * @param value
 * @param shouldUpdatePercentage
 * @returns {(function(*, *): void)|*}
 */
export function updateDailyCarbsIntakeGoalInGramProfileAction ({
  value,
  shouldUpdatePercentage
}) {
  const key = PROFILE_KEY.DAILY_CARBOHYDRATE_INTAKE_GOAL_IN_GRAM
  return (dispatch, getState) => {
    dispatch(
      updateProfileAction({
        type: getActionStrReduxUtil(
          REDUX_ACTION_PREFIX.UPDATE,
          key,
          value
        ),
        payload: {
          key,
          value
        }
      })
    )

    if (!shouldUpdatePercentage) {
      return
    }

    const macro = MACRONUTRIENT.CARBS
    const dailyCalorieIntakeGoal = getDailyCalorieIntakeGoalProfileSelect(getState())
    const dailyCarbsIntakeGoalInPercentage = (
      value * MACRONUTRIENT_TO_CALORIES_PER_GRAM[macro]
    ) / dailyCalorieIntakeGoal * 100

    dispatch(
      updateDailyCarbsIntakeGoalPercentageProfileAction({
        value: dailyCarbsIntakeGoalInPercentage
      })
    )

    dispatch(
      balanceDailyMacroIntakeGoalPercentageProfileAction({
        macroThatWasJustUpdated: macro
      })
    )
  }
}
